<template>
  <div>

    <el-form
      size="mini"
      label-position="left"
      label-width="100px"
      v-loading="loading"
    >
      <el-form-item label="Название">
        <div style="display: flex">
          <click-to-edit
            style="width: 100%"
            v-model="profile.name"
            @input="saveProfile(profile)"
          ></click-to-edit>

          <div style="margin-left:10px;width: 100px">ID: {{ profile.id }}</div>

          <el-button
            style="margin-right:20px"
            size="mini"
            :icon="showPermissions ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
            @click="showPermissions = !showPermissions"
          >
            {{ showPermissions ? 'Свернуть': 'Развернуть' }}
          </el-button>

          <el-popconfirm
            confirm-button-text='Да'
            cancel-button-text='нет'
            icon="el-icon-question"
            title="Вы уверены, что хотите удалить профиль?"
            @confirm="deleteProfile(profile)"
          >
            <el-button
              slot="reference"
              size="small"
              icon="fas fa-trash"
              :disabled="profile.id === 1"
            >

            </el-button>

          </el-popconfirm>
        </div>
      </el-form-item>
    </el-form>

    <el-table
      v-if="showPermissions"
      style="width: 100%"
      :data="permissionsToAccessLevels"
      empty-text="Нет истории"
      v-loading="loading"
      size="mini"
      max-height="500px"
    >
      <el-table-column fixed prop="description" label="Полномочие">
        <template slot="header">
          <el-input
            v-model="permissionsSearch"
            placeholder="Фильтр по названию полномочия"
            size="mini"
            clearable
            prefix-icon="el-icon-search"
          ></el-input>
        </template>
        <template slot-scope="scope">
          {{ scope.row.description }}
        </template>
      </el-table-column>
      <el-table-column
        v-for="(accessLevelName, accessLevelKey) in accessLevels"
        :key="accessLevelKey"
        :prop="accessLevelKey"
        :label="accessLevelName"
        v-slot="scope"
        align="center"
        width="110"
      >
        <el-switch
          v-model="scope.row[scope.column.property]"
          @change="permissionChanged(scope.row.name, scope.column.property, scope.row[scope.column.property])"
        ></el-switch>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "CascadingPermissionsProfilesEditForm",
  components: { ClickToEdit },
  props: {
    permissions: {type: Array, required: true},
    profile: {type: Object, required: true},
  },


  computed:{
    permissionsToAccessLevels() {
      const permissionsToReturn = [];

      this.permissions.forEach(permission => {
        const toReturn = {
          name: permission.name,
          description: permission.description,
        };
        Object.keys(this.accessLevels).forEach(accessLevelKey => {
          toReturn[accessLevelKey] = this.profile[accessLevelKey].includes(permission.name);
        })
        permissionsToReturn.push(toReturn);
      })

      return permissionsToReturn.filter(permission =>
        permission.description
          .toLowerCase()
          .includes(this.permissionsSearch.toLowerCase())
      );
    }
  },

  data() {
    return {
      loading: false,
      showPermissions: false,
      permissionsSearch: '',
      accessLevels: {
        'for_author': 'Владелец',
        'for_author_child': 'Владелец родителя',
        'for_responsible': 'Ответственный',
        'for_responsible_child': 'Ответственный родителя',
        'for_card_user': 'Владелец карты',
        'for_card_user_child': 'Владелец карты родителя',
        'for_card_participate': 'Участник карты',
        'for_other': 'Другие',
      }
    };
  },

  methods: {

    saveProfile(profile) {
      this.loading = true;
      this.$api.cascading.updatePermissionsProfile(profile)
        .finally(() => {
          this.loading = false;
        });
    },

    deleteProfile(profile) {
      this.loading = true;
      this.$api.cascading.deletePermissionsProfile({
        id: profile.id
      })
        .finally(() => {
          this.$emit('deleted', this.profile);
        });
    },

    permissionChanged(name, accessLevel, value) {
      this.loading = true;
      this.$api.cascading.updatePermissionValue({
        profile_id: this.profile.id,
        name: name,
        access_level: accessLevel,
        value: value,
      })
        .finally(() => {
          this.loading = false;
        });
    }


  }


};
</script>
